import axios from 'axios'
import qs from 'qs'

const apiService = axios.create({
  baseURL: `${process.env.VUE_APP_E360_BASE_URL}${process.env.VUE_APP_E360_REST_URL}`,
})

const ApiService = {
  prefix: process.env.VUE_APP_E360_REST_URL || 'jsf/',
  get(url, options = { headers: {} }) {
    return apiService.get(url, options).catch((error) => Promise.reject(error))
  },

  post(url, body = {}, options = { headers: {} }) {
    return apiService.post(url, body, options).catch((error) => Promise.reject(error))
  },

  put(url, body = {}, options = { headers: {} }) {
    return apiService.put(url, body, options).catch((error) => Promise.reject(error))
  },

  delete(url, body = {}, options = { headers: {} }) {
    if (Object.keys(body).length) {
      options.data = qs.stringify(body, { indices: false })
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }

    return apiService.delete(url, options).catch((error) => Promise.reject(error))
  },
}

export default ApiService
